var _circle, _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWheelInside(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67.9586,
    cy: 67.9581,
    r: 40.8712,
    fill: "#999999"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.5814 95.193C83.7351 96.7809 83.3916 99.0257 81.6722 99.9724C77.4882 102.276 72.7729 103.498 67.9584 103.498C63.144 103.498 58.4287 102.276 54.2447 99.9724C52.5253 99.0257 52.1818 96.7809 53.3355 95.193L65.0832 79.0236C66.5024 77.0703 69.4145 77.0703 70.8337 79.0236L82.5814 95.193Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5752 90.2814C45.4215 91.8693 43.1805 92.2362 41.7488 90.8935C38.2648 87.6263 35.6454 83.5194 34.1577 78.9406C32.6699 74.3618 32.3751 69.4996 33.2732 64.8085C33.6423 62.8807 35.671 61.8603 37.5377 62.4668L56.546 68.643C58.8423 69.3891 59.7422 72.1587 58.323 74.112L46.5752 90.2814Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1198 54.5198C38.253 53.9132 37.2116 51.8953 38.0461 50.1187C40.0769 45.7956 43.1734 42.0353 47.0683 39.2055C50.9632 36.3756 55.4963 34.5927 60.2354 33.9972C62.1829 33.7525 63.7803 35.3666 63.7803 37.3294L63.7803 57.3158C63.7803 59.7303 61.4243 61.442 59.128 60.6959L40.1198 54.5198Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1362 37.3295C72.1362 35.3667 73.7336 33.7526 75.6811 33.9973C80.4201 34.5928 84.9533 36.3757 88.8482 39.2055C92.7431 42.0354 95.8396 45.7957 97.8704 50.1187C98.7049 51.8953 97.6635 53.9133 95.7967 54.5198L76.7885 60.696C74.4922 61.4421 72.1362 59.7304 72.1362 57.3159L72.1362 37.3295Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3789 62.467C100.246 61.8604 102.274 62.8808 102.643 64.8086C103.541 69.4997 103.247 74.3619 101.759 78.9407C100.271 83.5195 97.6518 87.6264 94.1679 90.8937C92.7361 92.2364 90.4951 91.8695 89.3414 90.2815L77.5936 74.1122C76.1744 72.1588 77.0743 69.3892 79.3707 68.6431L98.3789 62.467Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3263_2207)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 67.9586,
    cy: 67.9581,
    r: 12.439,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.9583,
    cy: 67.9581,
    r: 3.55401,
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4821 115.518C33.0835 128.12 50.1773 135.2 67.9998 135.2L67.9983 129.822C51.603 129.822 35.8781 123.309 24.2837 111.715C12.6894 100.121 6.1758 84.3968 6.1758 68H0.799805C0.799805 85.8225 7.87985 102.915 20.4821 115.518Z",
    fill: "#FAFAFA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M115.517 20.4823C102.916 7.88004 85.8222 0.800003 67.9997 0.800003L68.0012 6.17754C84.3965 6.17754 100.121 12.6911 111.716 24.2854C123.31 35.8792 129.824 51.6032 129.824 68H135.2C135.2 50.1775 128.12 33.0846 115.517 20.4823Z",
    fill: "#FAFAFA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3263_2207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.0558,
    height: 25.0558,
    fill: "white",
    transform: "translate(55.4722 55.4721)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelInside);
export default __webpack_public_path__ + "static/media/wheel-inside.bcb2732435509740f2f6068f2ad11d5f.svg";
export { ForwardRef as ReactComponent };